namespace Matrix.Dashboards {
    export interface ChartSeriesForm {
        Field: FieldSelect;
        Title: Serenity.StringEditor;
        Type: Serenity.EnumEditor;
        BackgroundColor: ChartColorPicker;
        AreaFillColor: ChartColorPicker;
        ElementClickUrl: Serenity.StringEditor;
    }

    export class ChartSeriesForm extends Serenity.PrefixedContext {
        static formKey = 'Matrix.Dashboards.ChartSeriesForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ChartSeriesForm.init)  {
                ChartSeriesForm.init = true;

                var s = Serenity;
                var w0 = FieldSelect;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = ChartColorPicker;

                Q.initFormType(ChartSeriesForm, [
                    'Field', w0,
                    'Title', w1,
                    'Type', w2,
                    'BackgroundColor', w3,
                    'AreaFillColor', w3,
                    'ElementClickUrl', w1
                ]);
            }
        }
    }
}
